import React from 'react';
import PropTypes from 'prop-types';
import {privateStacksWith} from '../../../../../data/stackups/queries';
import {ListContainer} from '../../../../../shared/library/cards/card';
import ListCard from '../../../../../shared/library/cards/list-card';

const PrivateStacksUse = ({slug, items, title, disableScroll, limitItems}) => {
  return (
    <ListContainer>
      <ListCard
        disableScroll={disableScroll}
        title={title}
        itemsData={items}
        variables={{slug}}
        query={privateStacksWith}
        normalizeData={data => data.tool.privateStacksList}
        placeholder={'No integrations found'}
        limitItems={limitItems}
      />
    </ListContainer>
  );
};

PrivateStacksUse.propTypes = {
  slug: PropTypes.string,
  items: PropTypes.object,
  title: PropTypes.string,
  disableScroll: PropTypes.bool,
  limitItems: PropTypes.number
};

export default PrivateStacksUse;
